import { ApiSetProfile } from '../actions/Api';
import { UserProfileActions } from '../constants/UserProfile';

/**
 * action notifying of the intent to set profile for a given listener
 *
 * @param  {string} fullName - full name
 * @param  {string} homeTown - home town
 * @param  {string} school - school
 * @param  {string} employer - employer
 * @param  {string} bio - biography
 * @returns {object} - return an Action
 */
export function setProfile({ name, homeTown, school, employer, bio }) {
  const fullName = name;
  return dispatch => {
    return dispatch(ApiSetProfile({ fullName, homeTown, school, employer, bio }));
  };
}

export function resetErrorKey() {
  return {
    type: UserProfileActions.RESET_ERROR_KEY,
  };
}
